import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Review_Card.css";
import React from "react";
import { formatDate } from "../../../../utils/common";

const Review_Card = ({ ...props }) => {
  return (
    <div className="Review_Card">
      <div className="top_part">
        <div className="name_div">
          <p>{props?.review?.User?.name}</p>
        </div>
      </div>

      <div className="footer_part">
        <div className="review_tab">
          <p className="review_text">{props?.review?.review}</p>
          <div className="reviews_div">
            <div className="rating">
              <p>{props?.review?.ratings}</p>
            </div>
            <div className="star_div">
              <FontAwesomeIcon icon={faStar} className="star_icon" />
            </div>
          </div>
          {/* <p>
                        <FontAwesomeIcon icon={faStar} className="star_icon" />
                        <FontAwesomeIcon icon={faStar} className="star_icon" />
                        <FontAwesomeIcon icon={faStar} className="star_icon" />
                        <FontAwesomeIcon icon={faStar} className="star_icon" />
                        <FontAwesomeIcon icon={faStar} className="star_icon" />
                    </p> */}
        </div>

        <div className="img_holder">
          {props?.review?.Review_Images?.map((val) => (
            <img
              src={process.env.REACT_APP_IMG_URL + val?.image}
              className="product_image"
            />
          ))}
        </div>
      </div>

      <div className="date">
        <p>{formatDate(props?.review?.createdAt)}</p>
      </div>
    </div>
  );
};

export default Review_Card;
